module.exports = __webpack_public_path__ + "7d0cccb4cb3f788ce81f85e6dd07d8df.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/areas/areas-guardianship.jpg
// module id = 120
// module chunks = 0